import type { FunctionComponent } from 'react';

import { forTemplate } from '@trello/legacy-i18n';

import { Alerts } from 'app/scripts/views/lib/Alerts';

import styles from './PowerUpDistributionPage.less';

const format = forTemplate('app_management');

export const PowerUpDistributionPage: FunctionComponent<{
  idPlugin: string;
}> = ({ idPlugin }) => {
  const { host, protocol } = window.location;
  const enableUrl = `${protocol}//${host}/power-ups/${idPlugin}/enable`;

  const addToTrelloCodeSnippet = `<a href="${enableUrl}">
      <img
        alt="Add to Trello"
        height="40" width="144"
        src="https://p.trellocdn.com/add_to_trello.png"
        srcSet="https://p.trellocdn.com/add_to_trello.png 1x,
          https://p.trellocdn.com/add_to_trello@2x.png 2x"
      />
    </a>`.replace(/^ {4}/gm, '');

  return (
    <>
      <div className={styles.header}>
        <h1>{format('distribution')}</h1>
      </div>
      <p>{format('share-this-button-with-your-users')}</p>
      <div className={styles.enableButtonContainer}>
        <a href={enableUrl} rel="noopener noreferrer" target="_blank">
          <img
            alt="Add to Trello"
            height="40"
            width="144"
            src="https://p.trellocdn.com/add_to_trello.png"
            srcSet="https://p.trellocdn.com/add_to_trello.png 1x, https://p.trellocdn.com/add_to_trello@2x.png 2x"
          />
        </a>
      </div>
      <textarea
        className={styles.enableButtonSnippet}
        value={addToTrelloCodeSnippet}
        readOnly
        onClick={(e) => {
          e.currentTarget.select();
          document.execCommand('copy');
          Alerts.show('copied-to-clipboard', 'info', 'copiedtoclipboard', 3000);
        }}
      />
    </>
  );
};
